import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, ListGroup, Badge, Alert } from 'react-bootstrap';
import {
    FaClock,
    FaBan,
    FaMobileAlt,
    FaLaptop
} from 'react-icons/fa';
import AuthContext from '../Navbar/AuthContext';
import { fetchteacherSubscribers, resetInitialState, subscribeToTeacher, unsubscribetoTeacher, updateCreatorSubscription, updateCreatorSubscriptioninexam } from '../../actions/subscribers';
import { fetchUserDataRequest } from '../../actions/dashboardActions';

const ExamTearmsAndConditions = () => {
    const location = useLocation();
    const { test, studentProfileData } = location.state || {};
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAuthenticated } = useContext(AuthContext);

    // Redux state
    const techernamesubcriber = useSelector(state => state.subcriptiondata.techerData);
    const subcribeFail = useSelector(state => state.subcriptiondata.subcribeFail);
    const unsubcribeFail = useSelector(state => state.subcriptiondata.unsubcribeFail);
    const isSubscribed = useSelector(state => state.subcriptiondata.isSubscribed);

    // Local state
    const [loading, setLoading] = useState(false);
    const [accepted, setAccepted] = useState(false);
    const [showFullTerms, setShowFullTerms] = useState(false);
    const [localSubscribed, setLocalSubscribed] = useState(isSubscribed);
    const [subscriberCount, setSubscriberCount] = useState(techernamesubcriber?.subscribers?.length || 0);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState(null);

    const data = {
        testId: test?._id,
        studentId: studentProfileData?._id
    };
    useEffect(() => {
        setLocalSubscribed(isSubscribed);
    }, [isSubscribed]);

       useEffect(() => {
        setSubscriberCount(techernamesubcriber?.subscribers?.length);
    }, [techernamesubcriber]);

    useEffect(() => {
        if (!studentProfileData) {
            dispatch(fetchUserDataRequest())
        }
    }, []); 
    useEffect(() => {
        if (isAuthenticated && !techernamesubcriber) {
            dispatch(fetchteacherSubscribers(data));
        } else if(isAuthenticated === false) {
            navigate('/signin');
        }
    }, [isAuthenticated]);

    const handleSubscribe = () => {
        setLocalSubscribed(true);
        setSubscriberCount(prev => prev + 1);

        setLoading(true);
        dispatch(subscribeToTeacher(techernamesubcriber._id));
        const isSubscribed = true
        dispatch(updateCreatorSubscription(techernamesubcriber._id, studentProfileData._id, isSubscribed))
        dispatch(updateCreatorSubscriptioninexam(studentProfileData._id, isSubscribed))
    };

    const handleUnsubscribe = () => {

        setLocalSubscribed(false);
        setSubscriberCount(prev => Math.max(prev - 1, 0));
        // setLoading(true);
        dispatch(unsubscribetoTeacher(techernamesubcriber._id));
        const isSubscribed = false
        dispatch(updateCreatorSubscription(techernamesubcriber._id, studentProfileData._id, isSubscribed))
        dispatch(updateCreatorSubscriptioninexam(studentProfileData._id, isSubscribed))
    };

    const handleStartTest = () => {
        if (accepted) {
            navigate('/live-exam', { state: { test, studentProfileData } });
        }
    };

    const toggleFullTerms = () => {
        setShowFullTerms(!showFullTerms);
    };

    useEffect(() => {
        if (techernamesubcriber?.subscribers?.length >= 0) {
            setSubscriberCount(techernamesubcriber.subscribers.length);
        }
    }, []);

    useEffect(() => {
        if (subcribeFail || unsubcribeFail) {
            // Show error message immediately
            setError(subcribeFail ? 'Subscription failed. Please try again.' : 'Unsubscription failed. Please try again.');
            setShowError(true);

            // Set timeout to hide error and refetch after 3 seconds
            const timer = setTimeout(() => {
                setShowError(false);
                dispatch(resetInitialState())
                dispatch(fetchteacherSubscribers());
            }, 3000);

            // Clean up the timer if component unmounts
            return () => clearTimeout(timer);
        }
    }, [subcribeFail, unsubcribeFail]);

    return (
        <div className="py-5" style={{ maxWidth: '90%', alignContent: 'center', margin: 'auto' }}>
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <Card className="shadow">
                        <Card.Header className=" text-white" style={{ backgroundColor: '#0096c7' }}>
                            <h2 className="mb-0">Exam Terms and Conditions</h2>
                        </Card.Header>


                        <Card.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            <div className="mb-4">
                                <h4>General Instructions:</h4>
                                <p>
                                    <FaClock className="mr-2" />
                                    Total duration of <strong>{test?.testName}</strong> is <strong>{test?.totalMinutes} minutes</strong>.
                                </p>
                                <p>
                                    The countdown timer will display the remaining time available. When the timer reaches zero,
                                    the examination will automatically submit. You will not be required to manually submit.
                                </p>
                            </div>

                            <div className="mb-4">
                                <h5>Question Status Indicators:</h5>
                                <ListGroup>
                                    <ListGroup.Item className="d-flex align-items-center">
                                        <div
                                            className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2"
                                            style={{
                                                width: '24px',
                                                height: '24px',
                                                fontSize: '14px',
                                                border: 'none' // Removed border for solid color
                                            }}
                                        >
                                            1
                                        </div>
                                        You are currently on this question.
                                    </ListGroup.Item>



                                    {/* Answered */}
                                    <ListGroup.Item className="d-flex align-items-center">
                                        <div
                                            className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center me-2"
                                            style={{
                                                width: '24px',
                                                height: '24px',
                                                fontSize: '14px',
                                                border: 'none' // Removed border for solid color
                                            }}
                                        >
                                            1
                                        </div>
                                        You have answered the question.
                                    </ListGroup.Item>

                                    {/* Not Visited */}
                                    <ListGroup.Item className="d-flex align-items-center">
                                        <div
                                            className="rounded-circle text-primary border border-primary d-flex align-items-center justify-content-center me-2"
                                            style={{
                                                width: '24px',
                                                height: '24px',
                                                fontSize: '14px',
                                            }}
                                        >
                                            1
                                        </div>
                                        You have not visited the question yet.
                                    </ListGroup.Item>
                                </ListGroup>
                            </div>

                            {showFullTerms && (
                                <div className="mb-4">
                                    <h5>Exam Rules:</h5>
                                    <ul>
                                        <li className="mb-2">You must complete the exam independently without any external assistance</li>
                                        <li className="mb-2">Communication with others during the exam is strictly prohibited</li>
                                        <li className="mb-2">Use of unauthorized materials or devices is not allowed</li>
                                        <li className="mb-2">
                                            <FaLaptop className="mr-2" />
                                            You must maintain a stable internet connection throughout
                                        </li>
                                        <li className="mb-2">
                                            <FaMobileAlt className="mr-2" />
                                            Mobile phones and other electronic devices must be switched off
                                        </li>
                                        <li className="mb-2">
                                            <FaBan className="mr-2" />
                                            Any violation may result in immediate termination of your exam
                                        </li>
                                    </ul>
                                </div>
                            )}

                            <Button
                                variant="link"
                                onClick={toggleFullTerms}
                                className="p-0 mb-3"
                            >
                                {showFullTerms ? 'Show Less' : 'Show Full Terms and Conditions'}
                            </Button>

                            <div className="mb-4 p-3 bg-light rounded">
                                <h5>Declaration:</h5>
                                <p>
                                    I have read and understood all instructions. I declare that I am not in possession of any prohibited
                                    gadgets (mobile phones, Bluetooth devices, etc.) or prohibited materials. I agree that violating
                                    these rules may result in being debarred from this test and/or disciplinary action.
                                </p>
                            </div>

                            <div className="form-check mb-4">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="acceptTerms"
                                    checked={accepted}
                                    onChange={(e) => setAccepted(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="acceptTerms">
                                    I accept all terms and conditions stated above
                                </label>
                            </div>
                            {showError && error && (
                                <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
                                    {error}
                                </Alert>
                            )}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h5>Test Creator: {techernamesubcriber?.name}</h5>
                                    <Badge bg="info">
                                        Subscribers: {subscriberCount}
                                    </Badge>
                                </div>

                                <div>
                                    {localSubscribed ? (
                                        <Button
                                            variant="outline-danger"
                                            onClick={handleUnsubscribe}
                                        >
                                            Unsubscribe
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="outline-primary"
                                            onClick={handleSubscribe}
                                            disabled = {!techernamesubcriber}
                                        >
                                            Subscribe
                                        </Button>
                                    )}
                                </div>

                            </div>
                        </Card.Body>

                        <Card.Footer className="d-flex justify-content-between">
                            <Button
                                variant="secondary"
                                onClick={() => navigate(-1)}
                            >
                                Back to Dashboard
                            </Button>

                            <Button
                                variant="success"
                                onClick={handleStartTest}
                                disabled={!accepted}
                            >
                                Start Test Now
                            </Button>
                        </Card.Footer>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default ExamTearmsAndConditions;